import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["appearance", "children", "accessibilityLabelCloseButton", "onClose", "closeHidden", "show"];
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Checkmark, Close, Info } from '@mediahuis/chameleon-theme-wl/icons';
import Icon from '../Icon';
import Flex from '../Flex';
import Paragraph from '../Paragraph';
import IconButton from '../IconButton';
import styles from './index.module.css';
var SYSTEM_PROPS = ['flexProps', 'marginProps', 'floatProps', 'positioningProps'];

var getAppearanceProps = function getAppearanceProps(appearance) {
  switch (appearance) {
    case 'success':
      return {
        bgColor: 'green10',
        color: 'green70',
        icon: Checkmark
      };

    case 'error':
      return {
        bgColor: 'red10',
        color: 'red70'
      };

    default:
      return {
        bgColor: 'blue10',
        color: 'blue70'
      };
  }
};

const Banner = /*#__PURE__*/function () {
  const Banner = /*#__PURE__*/forwardRef(function (_ref, ref) {
    var appearance = _ref.appearance,
        children = _ref.children,
        accessibilityLabelCloseButton = _ref.accessibilityLabelCloseButton,
        onClose = _ref.onClose,
        closeHidden = _ref.closeHidden,
        show = _ref.show,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);

    if (!show) {
      return null;
    }

    var appearanceProps = getAppearanceProps(appearance); // NOTE: We don't use flex for IE11 reasoning

    return /*#__PURE__*/React.createElement(Flex, _extends({}, rest, {
      className: cx(styles.root, rest.className),
      bgColor: appearanceProps.bgColor,
      color: appearanceProps.color,
      position: "relative",
      px: 4,
      py: 4,
      ref: ref,
      role: "alert"
    }), /*#__PURE__*/React.createElement(Icon, {
      mt: 2,
      mb: "auto",
      size: "medium",
      as: appearanceProps.icon || Info,
      "aria-hidden": "true"
    }), /*#__PURE__*/React.createElement(Paragraph, {
      my: "auto",
      width: "full",
      pl: 4,
      pr: closeHidden ? 0 : 4,
      as: "div"
    }, children), closeHidden && /*#__PURE__*/React.createElement("span", {
      style: {
        minHeight: 32
      }
    }), !closeHidden && /*#__PURE__*/React.createElement(IconButton, {
      onClick: onClose,
      size: "small",
      icon: Close,
      accessibilityLabel: accessibilityLabelCloseButton
    }));
  });
  Banner.displayName = 'Banner';
  Banner.identifier = Banner.displayName; // used in docs website

  Banner.clonableProps = SYSTEM_PROPS;
  Banner.defaultProps = {
    accessibilityLabelCloseButton: 'Close',
    closeHidden: false
  };
  return Banner;
}();

export default Banner;